// src/Components/ServerExplorer/constants.js
import { createApiUrl } from '../../Config/apiConfig';

export const API_ENDPOINTS = {
    SERVER_DATA: createApiUrl('CoreflexData/fetch')
};

export const MARKET_MAPPING = {
    NJS: "New Jersey",
    NJP: "New Jersey",
    PAP: "Pennsylvania",
    PAS: "Pennsylvania",
    CTP: "Connecticut",
    CTS: "Connecticut",
    ONP: "Ontario",
    ONS: "Ontario",
    MIP: "Michigan",
    MIS: "Michigan",
};

export const INTEGRATION_TYPES = {
    GAMEFLEX: 'GameFlex',
    OGS: 'OGS',
    GGI: 'GGI'
};